__turbopack_context__.v({
  "DM_12_24_Link_B": "Select-module-scss-module__qDB8rG__DM_12_24_Link_B",
  "DM_14_24_Link_B": "Select-module-scss-module__qDB8rG__DM_14_24_Link_B",
  "DM_20_24_Bold": "Select-module-scss-module__qDB8rG__DM_20_24_Bold",
  "DM_Body_Reg_16": "Select-module-scss-module__qDB8rG__DM_Body_Reg_16",
  "DM_Bold_14_16": "Select-module-scss-module__qDB8rG__DM_Bold_14_16",
  "DM_Bold_14_24_UC": "Select-module-scss-module__qDB8rG__DM_Bold_14_24_UC",
  "DM_Bold_16_24": "Select-module-scss-module__qDB8rG__DM_Bold_16_24",
  "DM_Bold_20_24": "Select-module-scss-module__qDB8rG__DM_Bold_20_24",
  "DM_Bold_40_56": "Select-module-scss-module__qDB8rG__DM_Bold_40_56",
  "DM_Btn_16_16_Med": "Select-module-scss-module__qDB8rG__DM_Btn_16_16_Med",
  "DM_Med_10_12": "Select-module-scss-module__qDB8rG__DM_Med_10_12",
  "DM_Med_12_12_Chip": "Select-module-scss-module__qDB8rG__DM_Med_12_12_Chip",
  "DM_Med_12_16": "Select-module-scss-module__qDB8rG__DM_Med_12_16",
  "DM_Med_14_16": "Select-module-scss-module__qDB8rG__DM_Med_14_16",
  "DM_Med_14_20": "Select-module-scss-module__qDB8rG__DM_Med_14_20",
  "DM_Med_14_24": "Select-module-scss-module__qDB8rG__DM_Med_14_24",
  "DM_Med_16_16": "Select-module-scss-module__qDB8rG__DM_Med_16_16",
  "DM_Med_16_24": "Select-module-scss-module__qDB8rG__DM_Med_16_24",
  "DM_Med_18_24": "Select-module-scss-module__qDB8rG__DM_Med_18_24",
  "DM_Med_20_24": "Select-module-scss-module__qDB8rG__DM_Med_20_24",
  "DM_Med_24_24": "Select-module-scss-module__qDB8rG__DM_Med_24_24",
  "DM_Med_32_32": "Select-module-scss-module__qDB8rG__DM_Med_32_32",
  "DM_Med_32_48": "Select-module-scss-module__qDB8rG__DM_Med_32_48",
  "DM_Med_8_8": "Select-module-scss-module__qDB8rG__DM_Med_8_8",
  "DM_Reg_10_10": "Select-module-scss-module__qDB8rG__DM_Reg_10_10",
  "DM_Reg_12_12_Chip": "Select-module-scss-module__qDB8rG__DM_Reg_12_12_Chip",
  "DM_Reg_12_16": "Select-module-scss-module__qDB8rG__DM_Reg_12_16",
  "DM_Reg_14_16": "Select-module-scss-module__qDB8rG__DM_Reg_14_16",
  "DM_Reg_14_24": "Select-module-scss-module__qDB8rG__DM_Reg_14_24",
  "DM_Reg_14_32_Table": "Select-module-scss-module__qDB8rG__DM_Reg_14_32_Table",
  "DM_Reg_16_16_Chip": "Select-module-scss-module__qDB8rG__DM_Reg_16_16_Chip",
  "DM_Reg_16_20": "Select-module-scss-module__qDB8rG__DM_Reg_16_20",
  "DM_Reg_16_24": "Select-module-scss-module__qDB8rG__DM_Reg_16_24",
  "DM_Reg_16_24_Italic": "Select-module-scss-module__qDB8rG__DM_Reg_16_24_Italic",
  "DM_Reg_18_28": "Select-module-scss-module__qDB8rG__DM_Reg_18_28",
  "DM_Reg_32_32": "Select-module-scss-module__qDB8rG__DM_Reg_32_32",
  "DM_Reg_40_56": "Select-module-scss-module__qDB8rG__DM_Reg_40_56",
  "blue": "Select-module-scss-module__qDB8rG__blue",
  "container": "Select-module-scss-module__qDB8rG__container",
  "darkBlue": "Select-module-scss-module__qDB8rG__darkBlue",
  "drawer": "Select-module-scss-module__qDB8rG__drawer",
  "error": "Select-module-scss-module__qDB8rG__error",
  "fullWidth": "Select-module-scss-module__qDB8rG__fullWidth",
  "gray": "Select-module-scss-module__qDB8rG__gray",
  "icon": "Select-module-scss-module__qDB8rG__icon",
  "label": "Select-module-scss-module__qDB8rG__label",
  "loadMoreSpinner": "Select-module-scss-module__qDB8rG__loadMoreSpinner",
  "loader": "Select-module-scss-module__qDB8rG__loader",
  "medium": "Select-module-scss-module__qDB8rG__medium",
  "openUpward": "Select-module-scss-module__qDB8rG__openUpward",
  "options": "Select-module-scss-module__qDB8rG__options",
  "searchInput": "Select-module-scss-module__qDB8rG__searchInput",
  "searchInputWrapper": "Select-module-scss-module__qDB8rG__searchInputWrapper",
  "searchWrapper": "Select-module-scss-module__qDB8rG__searchWrapper",
  "selectWrapper": "Select-module-scss-module__qDB8rG__selectWrapper",
  "visible": "Select-module-scss-module__qDB8rG__visible",
  "withSearch": "Select-module-scss-module__qDB8rG__withSearch",
});
